import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Filter, BarChart, MicOff, Gift } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-cyan-400" data-id="element-176" />,
    title: 'El Manual Maestro (PDF)',
    desc: 'El paso a paso para configurar tu "Clon Digital" en 3 minutos.'
  }, {
    icon: <Filter className="w-6 h-6 text-cyan-400" data-id="element-177" />,
    title: 'El Filtro S.O.S.',
    desc: 'El sistema para resumir hilos de 50 correos y responder con autoridad en segundos.'
  }, {
    icon: <BarChart className="w-6 h-6 text-cyan-400" data-id="element-178" />,
    title: 'El Arquitecto de Reportes',
    desc: 'Cómo transformar datos crudos de Excel en narrativas que impresionen a tu jefe.'
  }, {
    icon: <MicOff className="w-6 h-6 text-cyan-400" data-id="element-179" />,
    title: 'El Secretario Silencioso',
    desc: 'El método para extraer tareas accionables de tus reuniones de Zoom sin tomar una sola nota.'
  }, {
    icon: <Gift className="w-6 h-6 text-[#22c55e]" data-id="element-180" />,
    title: 'Bono: La Bóveda de 50 Prompts',
    desc: '"Copia y Pega" para situaciones de crisis laboral.',
    highlight: true
  }];
  return <section className="py-24 bg-[#0d1322] border-y border-slate-800/50" data-id="element-181">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <FadeIn data-id="element-183">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-white mb-16" data-id="element-184">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-185">
          <div className="space-y-6" data-id="element-186">
            {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-187">
                <div className={`p-6 rounded-2xl border ${item.highlight ? 'bg-green-900/10 border-green-500/30 shadow-[0_0_20px_rgba(34,197,94,0.1)]' : 'bg-[#111827] border-slate-800'} flex gap-5 items-start`} data-id="element-188">
                  <div className={`p-3 rounded-xl ${item.highlight ? 'bg-green-500/20' : 'bg-slate-800'}`} data-id="element-189">
                    {item.icon}
                  </div>
                  <div data-id="element-190">
                    <h3 className={`text-xl font-bold mb-2 ${item.highlight ? 'text-[#22c55e]' : 'text-white'}`} data-id="element-191">
                      {item.title}
                    </h3>
                    <p className="text-[#d1d5db] leading-relaxed" data-id="element-192">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.3} direction="right" className="relative" data-id="element-193">
            <div className="absolute inset-0 bg-cyan-500/20 blur-[100px] rounded-full" data-id="element-194" />
            <img src="https://cdn.magicpatterns.com/uploads/t75UvnwREN2weZBfUwF5bS/heylloyd-image-1773283421267.png" alt="El Manual del Empleado Invisible en múltiples dispositivos" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-195" />
          </FadeIn>
        </div>
      </div>
    </section>;
}